HEIJS.registerNamespace("HEIJS.Search");
HEIJS.Search.AdvancedSearch = function (item, jsonUrlUrl, expressionVisitorName) {
  this.expressionVisitorName = expressionVisitorName;
  this.onSearch = new HEIJS.Event();
  this.onSearchCompleted = new HEIJS.Event();
  this.jsonUrl = HEIJS.context.convertToContextUri(jsonUrlUrl);
  this.init(item);
  this.inputControl.data('AdvancedSearch', this);
};

HEIJS.Search.AdvancedSearch.prototype = {
    // properties
    nodeTypes: { "Node": 0, "Parameter": 1, "Value": 2 },
    inputControl: null,
    jsonUrl: null,
    suggestionsDialog: null,
    operatorsDialog: null,
    currentOperator: null,
    previousOperator: null,
    throbber: null,
    minSearchInputLength: 3,
    expressionVisitorName: null,
    sortOrder: [],
    cleared: false,
    // events
    onSearch: null,
    onSearchCompleted: null,
    // methods
    init: function (item) {
        var self = this;
        this.inputControl = $(item);
        if (this.formMessages) {
            this.hideAllMessages();
        }
        this.inputControl.wrap("<div class='advanced-search'/>");
        $("div.advanced-search").prepend("<div class='advanced-search-filters'/>");
        $("div.advanced-search-filters").append("<ul class='filter-token-list'/>");

        this.inputControl.wrap("<div class='advanced-search-input'/>");
        this.inputControl.wrap("<div class='search ui-corner-all' />");
        var image = HEIJS.context.convertToContextUri("https://apps.hendersonengineers.com/resources/images/icons/magnifying_glass.png");
        var searchIcon = $("<a class='search-icon'><img src='" + image + "'/></a>");
        this.inputControl.parent("div.search").append(searchIcon);

        $(this.inputControl).watermark("Enter Search Text", {className: 'hei-watermark'});

        if ($('div.datepicker').length == 0) {
            $('body').append('<div class="datepicker"></div>');
            $('div.datepicker').hide();
            $('div.datepicker').mouseenter(function () {
                $(this).attr('active', true);
            });
            $('div.datepicker').mouseleave(function () {
                $(this).removeAttr('active');
            });
            $('div.datepicker').datepicker(
        {
            monthNames: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'Noveveber', 'December'],
            onSelect: function (dateText, inst) {
                self.suggestionsDialog.attr('IsMouseOver', true);
                var filterElement = $('div.datepicker').data('for').parents('li');
                var filter = filterElement.data('filter');
                $($('div.datepicker').data('for')).text(dateText);
                if ($('div.datepicker').data('for').hasClass('first')) {
                    filter.Right.Left.Value = filter.Right.Left.DisplayText = dateText;
                } else if ($('div.datepicker').data('for').hasClass('second')) {
                    filter.Right.Right.Value = filter.Right.Right.DisplayText = dateText;
                } else {
                    filter.Right.Value = dateText;
                }
                filterElement.data('filter', filter);
                $('div.datepicker').hide();
                $(this).removeAttr('active');
            },
            defaultDate: self.inputControl.val()
        });
        }

        $('a.search-icon', $("div.advanced-search")).click(function (parameters) {
            parameters.preventDefault();
            self.seachOnInput();
        });

        self.setupSuggestuionsDialog();
        self.setupOperatorsDialog();
        self.setupProjectControl();


        this.getLookupData();
        this.getContexts();
        this.setupEvents();
    },
    getControl: function (element) {
        return $(element).data('AdvancedSearch');
    },
    getFormMessages: function () {
        return HEIJS.page.formMessages[$("div.advanced-search").parents("div.form").attr('id')];
    },
    destroy: function () {
        //cleanup data
        $('div.suggested-filters ul.filters li', this.suggestionsDialog).removeData();
        this.inputControl.removeData();

        //remove dialogs
        this.suggestionsDialog.removeData();
        this.suggestionsDialog.remove();
        this.operatorsDialog.removeData();
        this.operatorsDialog.remove();

        // delete calendar
        $('div.datepicker').datepicker('destroy');
        $('div.datepicker').remove();

        // unwrap input
        this.inputControl.unwrap();

    },
    performSearch: function (sortOrder) {
        var self = this;
        var filters = [];
        $('li.filter-token-list-item').each(function (index) {
            filters.push($(this).data('filter'));
        });
        self.sortOrder = (!sortOrder || sortOrder.length == 0) ? self.sortOrder : sortOrder;
        var data = { expressionVisitorName: this.expressionVisitorName, search: this.inputControl.val(), filters: filters, sortOrder: self.sortOrder };
        if (!this.jsonUrl) {
            return;
        }
        $.post(
        this.jsonUrl + "?method=GetSearchQuery",
        JSON.stringify(data),
        function (data) {
            if (data != null && data.Success) {
                var data = data;
                try {
                    data = $.parseJSON(data.Data);
                } catch (e) {
                    data = data;
                }
                self.onSearch.Trigger({ Query: data.Data });
            } else {
                var formMessages = self.getFormMessages();
                if (formMessages) {
                    self.hideSuggestionsDialog(true);
                    if (data.Messages.length > 0) {
                        formMessages.showErrorMessage(data.Messages.join(". "), 0);
                    }
                }
            }
        }, 'json');
    },
    setupEvents: function () {
        var self = this;

        self.inputControl.click(function (event) { self.showSuggestionsDialog(event); });
        self.inputControl.focus(function (event) { self.showSuggestionsDialog(event); });
        self.inputControl.bind('DOMAutoComplete', function (parameters) {
            var control = $(this);
            var data = control.data;
            var currentValue = control.val();
            if (currentValue != data.previousValue) {
                control.change();
            }
        });

        self.inputControl.unbind('keyup');
        self.inputControl.bind('keyup', function (event) {
            self.onInputChnage(this, false);
        });
        self.inputControl.keypress(function (event) {
            var keyCode = event.keyCode ? event.keyCode : event.which;
            if (keyCode == 13) {
                self.seachOnInput(event);
            }
        });
        self.inputControl.select(function (e) { self.onInputChnage(this, false); });

        $('div.search-suggested-filters').click(function (parameters) {
            $('div.datepicker').removeData('for');
            $('div.datepicker').hide();
        });

        self.suggestionsDialog.mouseover(function () { self.suggestionsDialog.attr('IsMouseOver', true); });
        self.suggestionsDialog.mouseenter(function () { self.suggestionsDialog.attr('IsMouseOver', true); });
        self.suggestionsDialog.mouseleave(function (event) { self.suggestionsDialog.attr('IsMouseOver', false); });

        $("body").click(function (event) {
            var control = $(event.target);
            if (control.parents('.advanced-search-input').length == 0
                && control.parents('.ui-datepicker-header').length == 0) {
                self.hideSuggestionsDialog(event);
                if (self.operatorsDialog.is(":visible")) {
                    if (control.parents('.search-operators').length == 0) {
                        self.operatorsDialog.hide();
                    }
                }
            }
        });
    },
    seachOnInput: function (params) {
        var values = [];
        values.push(this.inputControl.val());
        values.push(this.inputControl.val());
        var jsonData = {
            method: "CreateFilter",
            defaultOperator: "",
            context: "",
            parameter: "",
            parameterType: "",
            filterValues: JSON.stringify(values),
            cache: false,
            async: false
        };
        var self = this;

        if (this.inputControl.val().length == 0) {
            self.performSearch(self.sortOrder);
        } else {
            $.get(this.jsonUrl, jsonData,
            function (data, textStatus) {
                if (data != null && data.Success) {
                    self.onFilterSelected(data.Data);
                } else {
                    var formMessages = self.getFormMessages();
                    if (formMessages) {
                        self.hideSuggestionsDialog(true);
                        if (data.Messages.length > 0) {
                            formMessages.showErrorMessage(data.Messages.join(". "), 0);
                        }
                    }
                }
            });
        }
    },
    hideSuggestionsDialog: function (immidiately) {
        var data = $(this).data;
        var self = this;

        if (!data.delayTimeout && !immidiately) {
            data.delayTimeout = setTimeout(function () { self.hideSuggestionsDialog(); }, 150);
            return;
        }

        if (data.delayTimeout) {
            delete data.delayTimeout;
            data.delayTimeout = null;
        }
        if (!this.suggestionsDialog.attr('IsMouseOver') || (this.suggestionsDialog.attr('IsMouseOver') == "false" ||
            this.suggestionsDialog.attr('IsMouseOver') == false)) {
            $('div.datepicker').hide();
            $('div.datepicker').removeData('for');
            this.suggestionsDialog.css('visibility', 'hidden');
            if ($('li.selected', $('div.advanced-search')).length > 0) {
                this.clearFilterSuggestions();
            }
            $('li.selected', $('div.advanced-search')).removeClass('selected');
            data.previousSearchTerm = this.inputControl.val();
        }
    },
    onInputChnage: function (sender, skipPrevCheck) {
        var self = this;
        var control = $(sender);

        self.showSuggestionsDialog();

        if (control.data('delayTimeout')) {
            clearTimeout(control.data('delayTimeout'));
            control.removeData('delayTimeout');
        } else {
            control.data('currentValue', control.val());
            control.data('delayTimeout', setTimeout(function () { self.onInputChnage(control, false); }, 200));
            return;
        }

        if (control.data('delayTimeout')) {
            clearTimeout(control.data('delayTimeout'));
            control.removeData('delayTimeout');
        }

        var currentValue = control.val();
        if (skipPrevCheck || (control.data('currentValue') == currentValue) || self.cleared) {
            self.cleared = false;
            self.ShowLoading();
            var selectedContext = $('div.contexts li.selected:last', 'div.advanced-search');
            var subContext = selectedContext.parent('ul.sub').length == 0 ? "" : selectedContext.text();
            var context = selectedContext.parent('ul.sub').length == 0 ? $('div.contexts li.selected:last a:first').text() : $('a:first', selectedContext.parent('ul.sub').parent('li')).text();
            if (!context) {
                context = $('div.contexts ul li:first').text();
            }

            self.getContextMatches(context, subContext, currentValue);
            if ($('div.suggested-filters input.project-search').length == 1 && !$('div.suggested-filters input.project-search').is(":disabled")) {
                // need to focus and simulate a key to get the project search control to trigger search events
                $('div.suggested-filters input.project-search').val(self.inputControl.val()).trigger('focus').trigger('keyup');
                ;
            }
        }
    },
    onOperatorChanged: function (sender) {
        var self = this;
        $('li.selected', $(sender).parent('ul')).removeAttr('class');
        self.operatorsDialog.hide();

        var filterElement = self.operatorsDialog.data('for');
        var filter = filterElement.data('filter');
        filter.Type = self.inputControl.data("OperatorTypes")[$(sender).attr('key')];
        filterElement.data('filter', filter);
        $('a', filterElement).text(self.CamlCaseToNormalString($(sender).attr('key')));
        $('a', filterElement).attr('key', $(sender).attr('key'));

        if (filter.Left.DataType.toLowerCase() != "string") {
            var values = [];
            values.push(self.inputControl.val());
            values.push(self.inputControl.val());

            $.get(self.jsonUrl,
        {
            method: "CreateFilter",
            defaultOperator: self.inputControl.data("OperatorTypes")[filter.Type].Value,
            context: filter.Context,
            parameter: filter.Left.DisplayText,
            parameterType: filter.Left.DataType,
            filterValues: JSON.stringify(values),
            cache: false, async: false
        },
        function (data, textStatus) {
            if (data != null && data.Success) {
                self.setupEditableFilter(filterElement, data.Data);
            } else {
                var formMessages = self.getFormMessages();
                if (formMessages) {
                    self.hideSuggestionsDialog(true);
                    if (data.Messages.length > 0) {
                        formMessages.showErrorMessage(data.Messages.join(". "), 0);
                    }
                }
            }
        });
        } else {
            // set the operator type on the current suggested filter list item
            filter.Type = self.inputControl.data("OperatorTypes")[$(sender).attr('key')];
        }
        self.operatorsDialog.removeData('for');
    },
    setupProjectControl: function () {
        var self = this;
        if ($('div.suggested-filters input.project-search').length == 0) {
            $('div.suggested-filters').append($('<input type="text" class="project-search"></input>'));
            $('div.suggested-filters input.project-search').ProjectSearchControl(
        {
            chosenLabel: false,
            closeOnProjectSelected: false,
            onProjectSelected: function (data) {
                self.onProjectSelected(data.project);
            }
        });
            $('#projectsearchcontrol-popup').appendTo($('div.suggested-filters'));
            this.Reposition($('#projectsearchcontrol-popup'), $('div.suggested-filters input.project-search'));
            $('div.suggested-filters input.project-search').hide();
        }
    },
    setupSuggestuionsDialog: function () {
        var div = $('<div class="search-suggested-filters"/>');
        $('div.advanced-search-input').append(div);
        div.append($('<div class="contexts"/>'));
        div.append($('<div class="suggested-filters"/>'));
        $('div.suggested-filters').append('<div class="loading"><img /><br />Loading</div>');
        // search instructions
        $('div.suggested-filters').append('<div class="instructions"></div>');
        $('div.suggested-filters div.instructions').html('Start typing search terms for search context hints or <br />'
            + 'Choose a context on the left for more options.');
        this.throbber = new HEIJS.Controls.Throbber($("div.loading img", $('div.suggested-filters')));
        this.throbber.preloadImages();
        div.hide();
        this.HideLoading();
        this.suggestionsDialog = div;
    },
    setupOperatorsDialog: function () {
        var div = $('<div class="search-operators"></div>');
        $('div.advanced-search-input').append(div);
        div.append('<ul/>');
        div.hide();
        div.mouseleave(function () {
            $(this).hide();
        });
        div.focusout(function () {
            $(this).hide();
        });
        this.operatorsDialog = div;
    },
    Reposition: function (dialog, control) {
        dialog.position(
      {
          of: $(control),
          my: "left top",
          at: "left bottom",
          offset: "0 2",
          collision: "flip"
      }
    );
    },
    getLookupData: function () {
        var self = this;
        $.get(this.jsonUrl, {
            method: "GetOperatorTypes", parameterType: "All", cache: false, async: false
        }, function (data, textStatus) {
            if (data != null && data.Success) {
                var OperatorTypes = [];
                $(data.Data).each(function (index) {
                    // exclude operators that are not use for comparison
                    OperatorTypes[this.Key] = this;
                    OperatorTypes[this.Value] = this.Key;
                });
                self.inputControl.data("OperatorTypes", OperatorTypes);
            } else {
                var formMessages = self.getFormMessages();
                if (formMessages) {
                    self.hideSuggestionsDialog(true);
                    if (data.Messages.length > 0) {
                        formMessages.showErrorMessage(data.Messages.join(". "), 0);
                    }
                }
            }
        });

        $.get(this.jsonUrl, { method: "GetExpressionTypes", cache: false, async: false }, function (data, textStatus) {
            if (data != null && data.Success) {
                self.inputControl.data("ExpressionTypes", data.Data);
            } else {
                var formMessages = self.getFormMessages();
                if (formMessages) {
                    self.hideSuggestionsDialog(true);
                    if (data.Messages.length > 0) {
                        formMessages.showErrorMessage(data.Messages.join(". "), 0);
                    }
                }
            }
        });
    },
    getOperatorTypesForType: function (control, parameterType) {
        var self = this;
        // get the lookup date from the operators dialog
        var controlData = self.operatorsDialog.data('data');
        // no data or Type is different, get results from server
        if (!controlData || controlData.Type != parameterType) {
            $.get(self.jsonUrl,
          {
              method: "GetOperatorTypes", parameterType: parameterType,
              cache: false, async: false
          }, function (data, textStatus) {
              if (data != null && data.Success) {
                  self.operatorsDialog.data('data', { Type: parameterType, Operators: data.Data })
                  self.showOperatorDialog(control);
              } else {
                  var formMessages = self.getFormMessages();
                  if (formMessages) {
                      self.hideSuggestionsDialog(true);
                      if (data.Messages.length > 0) {
                          formMessages.showErrorMessage(data.Messages.join(". "), 0);
                      }
                  }
              }
          });
        } else {
            self.showOperatorDialog(control);
        }
    },
    getContexts: function () {
        var self = this;
        $.get(this.jsonUrl, { method: "GetSearchContexts", cache: false, async: false }, function (data, textStatus) {
            var ul = $("<ul/>");
            $('.contexts', self.suggestionsDialog).append(ul);
            if (data != null && data.Success) {
                for (var idx = 0; idx < data.Data.length; idx++) {
                    var contextName = data.Data[idx].Name;
                    var context = $("<li><a>" + contextName + "</a></li>");
                    ul.append(context);

                    context.click(function (parameters) {
                        $('li.selected', $("div.contexts ul")).removeClass('selected');
                        $(this).attr('class', 'selected');
                        self.getContextMatches($('li.selected>a').text(), "", self.inputControl.val());
                        self.inputControl.focus().keyup();
                        parameters.stopPropagation();
                    });

                    self.getContextMatches(contextName, null, "", true);

                    if (data.Data[idx].SubContexts.length > 0) {
                        var subUl = $("<ul class='sub'/>");
                        context.append(subUl);
                        for (var idx1 = 0; idx1 < data.Data[idx].SubContexts.length; idx1++) {
                            var subContextName = data.Data[idx].SubContexts[idx1];
                            var subItem = $("<li><a>" + subContextName + "</a></li>");
                            subUl.append(subItem);
                            $(subItem).click(function (parameters) {
                                $('li.selected', $("div.contexts ul")).removeClass('selected');
                                $(this).attr('class', 'selected');
                                self.getContextMatches($(this).parent('ul').parent('li').find('>a').text(), $('a', $(this)).text(), self.inputControl.val());
                                self.inputControl.focus().keyup();
                                parameters.stopPropagation();
                            });
                            self.getContextMatches(contextName, subContextName, "", true);
                        }
                    }
                }
            } else {
                var formMessages = self.getFormMessages();
                if (formMessages) {
                    self.hideSuggestionsDialog(true);
                    if (data.Messages.length > 0) {
                        formMessages.showErrorMessage(data.Messages.join(". "), 0);
                    }
                }
            }
        });
    },
    getContextMatches: function (context, subContext, input, preLoading) {
        var ul = $('div.suggested-filters ul.filters', this.suggestionsDialog);
        $('li', ul).removeData();
        $('li', ul).remove();
        var self = this;
        if (!preLoading) {
            if (context == "Project" && !subContext) {
                self.HideLoading();
                ul.hide();
                self.Reposition($('#projectsearchcontrol-popup'), $('div.suggested-filters input.project-search'));
                $('div.suggested-filters input.project-search').val(this.inputControl.val()).trigger('focus').trigger('keyup');
                $('div.suggested-filters input.project-search').prop('disabled', false);

            } else {
                ul.hide();
                if (input.length > 0) {
                    self.ShowLoading();
                } else {
                    self.showInstructions();
                }

                $('#projectsearchcontrol-popup').hide();
                $('div.suggested-filters input.project-search').prop('disabled', true);
            }
        }
        $.get(this.jsonUrl, {
            method: "GetSearchFilters",
            context: context,
            subContext: subContext,
            searchTerm: input,
            defaultOperator: self.currentOperator,
            cache: false,
            async: false
        },
            function (data, textStatus) {
                if (preLoading) {
                    return;
                }
                var ul = $('div.suggested-filters ul.filters', self.suggestionsDialog);
                $('li', ul).removeData();
                $('li', ul).remove();
                if (ul.length == 0) {
                    ul = $("<ul class='filters'/>");
                    $('div.suggested-filters', self.suggestionsDialog).append(ul);
                }
                var searchTerm = $('div.advanced-search-input input.advanced-search-input').val();
                if (data != null && data.Success && data.Data.SearchTerms == searchTerm) {
                    for (var idx = 0; idx < data.Data.Items.length; idx++) {
                        self.createContextFilterItem(input, ul, data.Data.Items[idx]);
                    }
                    if (data.Data.Items.length == 0) {
                        self.createContextFilterItem(input, ul, null);
                    }
                }
                else {
                    if (data != null && data.Success) {
                        self.createContextFilterItem(input, ul, null);
                    } else {
                        var formMessages = self.getFormMessages();
                        if (formMessages) {
                            self.hideSuggestionsDialog(true);
                            if (data.Messages.length > 0) {
                                formMessages.showErrorMessage(data.Messages.join(". "), 0);
                            }
                        }
                    }
                }
                self.HideLoading();
                // only display if not project search
                if ((context != "Project" || subContext) && (data != null && data.Success && data.Data.SearchTerms.length > 0)) {
                    ul.show();
                }
                self.showInstructions();
            });
    },
    showSuggestionsDialog: function (event) {
        this.hideSuggestionsDialog(true);
        var data = $(this).data;
        this.suggestionsDialog.show();
        this.suggestionsDialog.css('visibility', 'hidden');
        this.Reposition(this.suggestionsDialog, this.inputControl.parents('div.search'));
        this.suggestionsDialog.css('visibility', '');
        if (data.previousSearchTerm != this.inputControl.val() || this.cleared) {
            this.cleared = false;
            data.previousSearchTerm = this.inputControl.val();
            this.inputControl.trigger("keyup");
        }
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        this.showInstructions();

        return false;
    },
    showInstructions: function () {
        if (this.inputControl.val().length == 0 && $('div.contexts ul li.selected').length == 0) {
            $("div.search-suggested-filters div.suggested-filters div.instructions").show();
            $('div.suggested-filters ul.filters', this.suggestionsDialog).hide();
            $('div.suggested-filters div.loading').hide();
        } else {
            $("div.search-suggested-filters div.suggested-filters div.instructions").hide();
            $('div.suggested-filters ul.filters', this.suggestionsDialog).show();
        }
    },
    showOperatorDialog: function (control) {
        // get the lookup date from the operators dialog
        var controlData = this.operatorsDialog.data('data');
        $('ul li', this.operatorsDialog).remove();
        var self = this;
        $(controlData.Operators).each(function (index) {
            if (this.Value != "Or" && this.Value != "And" && this.Value != "None") {
                $('ul', self.operatorsDialog).append($('<li key=' + this.Value + '>' + self.CamlCaseToNormalString(this.Value) + '</li>'));
            }
        });

        $('li', this.operatorsDialog).click(function (parameters) {
            self.onOperatorChanged(this);
            parameters.preventDefault();
            parameters.stopPropagation();
        });

        $('li:contains(' + control.text() + ')', this.operatorsDialog).each(function (index) {
            if ($(this).text() == control.text()) {
                $(this).addClass('selected');
            }
        });
        this.operatorsDialog.show();
        this.Reposition(this.operatorsDialog, control);
    },
    ShowLoading: function () {
        $('div.suggested-filters ul.filters', this.suggestionsDialog).hide();
        $("div.search-suggested-filters div.suggested-filters div.instructions").hide();
        $('div.suggested-filters div.loading').show();
        this.throbber.start();
    },
    HideLoading: function () {
        $('div.suggested-filters div.loading').hide();
        this.throbber.stop();
    },
    createContextFilterItem: function (searchTerm, parent, filter) {
        var self = this;
        // get the value expression display text
        var displayText = filter != null ? filter.Right.DisplayText : "No Matches";

        var filterElement = null;
        if (displayText) {
            var regex = new RegExp(searchTerm, 'gi');
            jQuery.unique($(displayText.match(regex))).each(function (index) {
                if (this.length > 0) {
                    displayText = displayText.replace(new RegExp(this, 'g'), '<b>' + this + '</b>');
                }
            });

            filterElement = $("<li " + (!$("li:last", parent).hasClass('altrow') && $("li", parent).length > 0 ? "class='altrow'" : "") + ">" + displayText + "</li>");
            parent.append(filterElement);
        } else {
            var operator = self.inputControl.data('OperatorTypes')[filter.Type].Value;
            var operatorKey = self.inputControl.data('OperatorTypes')[filter.Type].Key;
            var field = filter.Left.DisplayText;

            // need to display the context, in the context of "All Text Fields"
            var selectedContext = $('div.contexts li.selected:last', 'div.advanced-search');
            var displayContext = selectedContext.length == 0 ? true : selectedContext.text().indexOf('All Text') != -1;
            displayContext = displayContext && (field.toLocaleLowerCase().indexOf(filter.Context.toLocaleLowerCase()) == -1
            && self.CamlCaseToNormalString(field).toLocaleLowerCase().indexOf(filter.Context.toLocaleLowerCase()) == -1)
            // one special case when right operand is a node
            var filterValue = "";
            if (filter.Right.NodeType == self.nodeTypes["Node"]) {
                filterElement = $("<li " + (!$("li:last", parent).hasClass('altrow') && $("li", parent).length > 0 ? "class='altrow'" : "") + ">"
                    + '<span>' + (displayContext ? filter.Context + " " : "")
                    + self.CamlCaseToNormalString(field) + '</span>'
                    + " <a operatorKey='" + operatorKey + "'>" + self.CamlCaseToNormalString(operator) + "</a> "
                    + '<span class="filter-value"/>'
                    + "</li>");
                filterValue = filter.Right.Left.Value
                    + " " + self.inputControl.data('OperatorTypes')[filter.Right.Type].Value
                    + " "
                    + filter.Right.Right.Value;
            } else {
                filterElement = $("<li " + (!$("li:last", parent).hasClass('altrow') && $("li", parent).length > 0 ? "class='altrow'" : "") + ">"
                    + '<span>'
                    + (displayContext ? filter.Context + " " : "") + self.CamlCaseToNormalString(field)
                    + '</span>'
                    + " <a operatorKey='" + operatorKey + "'>" + self.CamlCaseToNormalString(operator) + "</a> "
                    + '<span class="filter-value"/>'
                    + "</li>");
                filterValue = filter.Right.Value;
            }
            parent.append(filterElement);
            var regex = new RegExp(searchTerm, 'gi');
            jQuery.unique($(filterValue.match(regex))).each(function (index) {
                if (this.length > 0) {
                    filterValue = filterValue.replace(new RegExp(this, 'g'), '<b>' + this + '</b>');
                }
            });
            $('span.filter-value', filterElement).html($("<span>" + filterValue + "</span>"));

            $('a:first', filterElement).click(function (parameters) {
                parameters.preventDefault();
                parameters.stopPropagation();
                self.operatorsDialog.data('for', filterElement);
                self.operatorsDialog.hide();
                var filter = filterElement.data('filter');
                self.getOperatorTypesForType($(this), filter.Left.Name.indexOf("AllText") < 0 ? filter.Left.DataType : '');
            });
        }

        if (filterElement) {
            filterElement.data('filter', filter);
            filterElement.click(function (parameters) {
                parameters.preventDefault();
                var filterData = $(this).data('filter');
                self.onFilterSelected(filterData);
                parameters.stopPropagation();
            });
            self.setupEditableFilter(filterElement, filter);
        }
    },
    setupEditableFilter: function (filterElement, filter) {
        var self = this;

        if (!filter) {
            return;
        }
        $('div.datepicker').hide();
        $(filterElement).data('filter', filter);
        if (filter.Left.DataType.toLowerCase() == "datetime") {
            $('span.filter-value', filterElement).remove();
            $('span.operator', filterElement).remove();
            if (self.inputControl.data("OperatorTypes")[filter.Type].Value.toLocaleLowerCase() == "between") {
                $(filterElement).append($('<span class="filter-value first">'
                    + (filter.Right.Left ? filter.Right.Left.Value : '1/1/2001')
                    + '</span><span class="operator">&nbsp;and&nbsp;</span><span class="filter-value second">'
                    + (filter.Right.Right ? filter.Right.Right.Value : '1/1/2001')
                    + '</span>'));

            } else {
                $(filterElement).append($('<span class="filter-value">'
                    + filter.Right.Value
                    + '</span>'));
            }
            $(filterElement).find('span.filter-value').addClass('editable');

            $('span.filter-value').click(function (parameters) {
                self.suggestionsDialog.attr('IsMouseOver', true);
                $('div.datepicker').data('for', $(this));
                $('div.datepicker').attr('active', true);
                $('div.datepicker').datepicker("setDate", $(this).text());
                $('div.datepicker').show();
                self.Reposition($('div.datepicker'), $(this));
                parameters.stopPropagation();
            });
            $('span.filter-value').hover(function (parameters) {
                self.suggestionsDialog.attr('IsMouseOver', true);
            }, function () {
                if (!$('div.datepicker').attr('active')) {
                    $('div.datepicker').hide();
                    $('div.datepicker').removeData('for');
                    $(this).removeAttr('active');
                }
            });
        } else if (filter.Left.DataType.toLowerCase() != "string") {
            if (self.inputControl.data("OperatorTypes")[filter.Type].Value.toLocaleLowerCase() == "between") {

                $('span.filter-value', filterElement).remove();
                $('span.operator', filterElement).remove();
                $('input.filter-value', filterElement).remove();

                $(filterElement).append($('<input class="filter-value first" value="' + filter.Right.Left.Value + '"></input>'));
                $(filterElement).append(' <span class="operator">and</span>');
                $(filterElement).append(' <input class="filter-value second" value="' + filter.Right.Right.Value + '"></input>');


                $(filterElement).find('input.filter-value').click(function (parameters) {
                    parameters.stopPropagation();
                });
                $(filterElement).find('span.filter-value').addClass('editable');

                $('input.filter-value', $(filterElement)).change(function (parameters) {
                    if ($(this).hasClass('first')) {
                        filter.Right.Left.Value = $(this).val();
                    } else {
                        filter.Right.Right.Value = $(this).val();
                    }
                    $(filterElement).data('filter', filter);
                });
                $('input.filter-value', $(filterElement)).keydown(function(parameters) {
                    // Allow: backspace, delete, tab and escape
                    if (parameters.keyCode == 46 || parameters.keyCode == 8 || parameters.keyCode == 9 || parameters.keyCode == 27 ||
                        // Allow: Ctrl+A
                        (parameters.keyCode == 65 && parameters.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (parameters.keyCode >= 35 && parameters.keyCode <= 39)) {
                        // let it happen, don't do anything
                        return;
                    } else {
                        // Ensure that it is a number and stop the keypress
                        if (parameters.shiftKey || (parameters.keyCode < 48 || parameters.keyCode > 57) && (parameters.keyCode < 96 || parameters.keyCode > 105)) {
                            parameters.preventDefault();
                        }
                    }
                });
            }
        }
    },
    clearFilterSuggestions: function () {
        $('div.suggested-filters ul.filters li').remove();
        this.cleared = true;
    },
    CamlCaseToNormalString: function (input) {
        var result = input.replace(/([A-Z][a-z])/g, " $1").replace(/^./, function (str) { return str.toUpperCase(); });
        return result.trim();
    },
    verifyFilterLength: function (filter) {
        // estimate the size of the current filter
        var currentFilterSize = 0;
        $('li.filter-token-list-item').each(function (index) {
            var existingFilter = $(this).data('filter');
            currentFilterSize +=
                existingFilter.Left.Name.length
                    + existingFilter.right.Value.length
                        + this.inputControl.data('OperatorTypes')[existingFilter.Type].Value
                            + 4; // estimated offset for spaces and parentecies
        });
        // add new filter length
        currentFilterSize +=
                filter.Left.Name.length
                    + filter.right.Value.length
                        + this.inputControl.data('OperatorTypes')[filter.Type].Value
                            + 4; // estimated offset for spaces and parentecies
        if (currentFilterSize > 2000) {
            self.hideSuggestionsDialog(true);
            var formMessages = this.getFormMessages();
            formMessages.showErrorMessage("Cannot add any more filters. "
            + "You have added the maximum allowed filters. "
            + "To add more filters please remote some of your existing filters.", 0);
            return false;
        } else {
            return true;
        }
    },
    onFilterSelected: function (filter) {
        if (!filter) {
            return;
        }

        var filterData = filter;

        var operator = this.inputControl.data('OperatorTypes')[filterData.Type].Value;
        var field = filterData.Left.DisplayText;

        var filterElement = null;
        // one special case when right side is a node
        var isContextContainedInField = field.indexOf(this.CamlCaseToNormalString(filterData.Context)) > 0;
        if (filterData.Right.NodeType == this.nodeTypes["Node"]) {
            var filterElement = $('<li class="filter-token-list-item"><p>'
                + (isContextContainedInField ? this.CamlCaseToNormalString(filterData.Context) + ' ' : '')
                + this.CamlCaseToNormalString(field)
                + ' ' + this.CamlCaseToNormalString(operator) + ' '
                + '<b>'
                + (filterData.Right.Left.DisplayText ? filterData.Right.Left.DisplayText : filterData.Right.Left.Value)
                + " " + this.inputControl.data('OperatorTypes')[filterData.Right.Type].Value + " "
                + (filterData.Right.Right.DisplayText ? filterData.Right.Right.DisplayText : filterData.Right.Right.Value)
                + '</b>'
                + '</p><span>×</span></li>');
        } else {
            var value = (filterData.Right.DisplayText ? filterData.Right.DisplayText : filterData.Right.Value);
            var filterElement = $('<li class="filter-token-list-item"><p>'
                + (isContextContainedInField ? this.CamlCaseToNormalString(filterData.Context) + ' ' : '')
                + this.CamlCaseToNormalString(field) + ' ' + this.CamlCaseToNormalString(operator) + ' ' + '<b>' + value + '</b>'
                + '</p><span>×</span></li>');
        }

        $('div.advanced-search-filters ul.filter-token-list').append(filterElement);
        filterElement.data('filter', filterData);
        var self = this;
        $('span:last', filterElement).click(function (parameters) {
            parameters.preventDefault();
            $(this).parent('li').removeData();
            $(this).parent('li').remove();
            self.performSearch(self.sortOrder);
        });

        $('p', filterElement).click(function (parameters) {
            parameters.preventDefault();
            self.inputControl.val(self.filterToString($(this).parent('li').data('filter'))).focus().change();
            $(this).parent('li').removeData();
            $(this).parent('li').remove();
            self.cleared = true;
            self.showSuggestionsDialog();
        });

        $(filterElement).attr('title', self.CamlCaseToNormalString(self.filterToString(filter)));
        // clear input string and callapse window and reset the currentOperator
        this.suggestionsDialog.hide();
        this.inputControl.val('').change();
        this.clearFilterSuggestions();
        this.currentOperator = null;
        self.performSearch(self.sortOrder);
    },
    filterToString: function (filter) {
        if (!filter) {
            return "";
        }

        var filterData = filter;

        var operator = this.inputControl.data('OperatorTypes')[filterData.Type].Value;
        var field = filterData.Left.DisplayText;
        var expression = null;
        // one special case when right side is a node
        if (filterData.Right.NodeType == this.nodeTypes["Node"]) {
            var expression =
                field + ' ' + this.CamlCaseToNormalString(operator) + ' '
                + (filterData.Right.Left.DisplayText ? filterData.Right.Left.DisplayText : filterData.Right.Left.Value)
                + " " + this.inputControl.data('OperatorTypes')[filterData.Right.Type].Value + " "
                + (filterData.Right.Right.DisplayText ? filterData.Right.Right.DisplayText : filterData.Right.Right.Value);
        } else {
            var value = (filterData.Right.DisplayText ? filterData.Right.DisplayText : filterData.Right.Value);
            expression = field
                + ' ' + this.CamlCaseToNormalString(operator)
                + ' ' + value;
        }
        return expression;
    },
    onProjectSelected: function (project) {
        var filterElement = $('div.suggested-filters ul.filters li:first');
        var filterData = filterElement.data('filter');
        if (filterData) {

            filterData.Left.Name = "ProjectNumber";
            filterData.Left.DisplayText = "ProjectNumber";
            filterData.Right.Value = project.value;
            filterData.Right.DisplayText = project.value;
            filterData.Context = "Project";
            filterData.Type = this.inputControl.data('OperatorTypes')["Equals"];
            this.onFilterSelected(filterData);
        }
    }
};